import { Avatar, Card, CardContent, Grid, Typography, Stack, Button, Box } from '@mui/material';
import { SwitchSatuanPD } from '../../helper/functionSensor';

export const CarPD = ({ handleClick, title, value, isLoad }) => {
  const exceptionAllButton = ["RSSI", "Arus"]
  const exceptionIOButton = ["Volt PDU"]
  const metaTitle = title.split(" ")

  return (
    <Card sx={{ height: "100%" }}>
      {/* {title} */}
      <CardContent>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: "space-between" }}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="overline"
            >
              {title}
            </Typography>
            <Box sx={{ display: "flex" }}>
              <Typography
                variant="h3"
                color="#01579b"
              >
                {value}
              </Typography>
              <Typography
                variant="h5"
                color="text.secondary"
              >
                {SwitchSatuanPD(title)}
              </Typography>
            </Box>
          </Grid>
          {!exceptionAllButton.includes(title) && (
            <Grid item>
              <Stack spacing={1}>
                {!exceptionIOButton.includes(title) && (
                  <>
                    <Button disabled={isLoad} onClick={() => handleClick(metaTitle[1], "On")} size="small" color="success" variant="outlined">On</Button>
                    <Button disabled={isLoad} onClick={() => handleClick(metaTitle[1], "Off")} size="small" color="error" variant="outlined">Off</Button>
                  </>
                )}
                <Button disabled={isLoad} onClick={() => handleClick(metaTitle[1], "Reset")} size="small" color="warning" variant="outlined">Restart</Button>
              </Stack>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}
